export default __webpack_public_path__ + "static/media/gow.4c5b9fd8.jpg";